"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Home = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _uxcore = require("@ux/uxcore2");

var _Style = _interopRequireDefault(require("../components/Style"));

var _Welcome = _interopRequireDefault(require("../components/Welcome"));

var _actions = require("../store/actions");

var _topics = require("../store/reducers/topics");

var _styles = _interopRequireDefault(require("../styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TopicItem = function TopicItem(_ref) {
  var topic = _ref.topic;
  return _react.default.createElement("div", {
    className: "help--home-topic-container"
  }, _react.default.createElement("span", {
    className: "help--home-topic-name"
  }, topic.name), _react.default.createElement(_uxcore.Icon, {
    name: "chevron-right-lt",
    size: 18,
    color: _styles.default.colors.grayMedium
  }));
};

TopicItem.propTypes = {
  topic: _propTypes.default.object.isRequired
};

var Home =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Home, _PureComponent);

  function Home(props) {
    var _this;

    _classCallCheck(this, Home);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Home).call(this, props));
    _this.handleClickLink = _this.handleClickLink.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Home, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.props.appTopicIdClear();
                _context.next = 3;
                return this.fetch();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.props.topics) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.props.topicsGet();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetch() {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "handleClickLink",
    value: function handleClickLink(topicId) {
      this.props.trafficTopicClick({
        topicId: topicId
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var topics = this.props.topics;
      return _react.default.createElement("div", {
        className: "help--home-container"
      }, _react.default.createElement(_Welcome.default, null), _react.default.createElement("div", null, topics ? topics.slice(0, 8).map(function (topic) {
        return _react.default.createElement(_reactRouterDom.Link, {
          className: "help--home-topic-link",
          to: "/topic/".concat(topic.id),
          key: topic.id,
          onClick: function onClick() {
            _this2.handleClickLink(topic.id);
          }
        }, _react.default.createElement(TopicItem, {
          topic: topic
        }));
      }) : _react.default.createElement(_react.Fragment, null, Array(8).fill().map(function (item, index) {
        return _react.default.createElement("div", {
          key: index
        }, _react.default.createElement(TopicItem, {
          topic: {
            name: "\xA0"
          }
        }));
      }))), _react.default.createElement(_Style.default, {
        css: "\n          .help--home-container {}\n\n          .help--home-topic-link {\n            color: inherit;\n          }\n          .help--home-topic-link, .help--home-topic-link:hover {\n            text-decoration: none;\n          }\n\n          .help--home-topic-container {\n            align-items: center;\n            border-bottom: 1px solid ".concat(_styles.default.colors.grayLight, ";\n            display: flex;\n            padding: 1.5em;\n          }\n\n          .help--home-topic-name {\n            flex: 1;\n            font-size: 1.25em;\n          }\n        ")
      }));
    }
  }]);

  return Home;
}(_react.PureComponent);

exports.Home = Home;
Home.propTypes = {
  appTopicIdClear: _propTypes.default.func.isRequired,
  topics: _topics.topicsPropType,
  topicsGet: _propTypes.default.func.isRequired,
  trafficTopicClick: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    topics: Array.isArray(state.topics) ? state.topics : null
  };
};

var mapDispatchToProps = {
  appTopicIdClear: _actions.appTopicIdClear,
  topicsGet: _actions.topicsGet,
  trafficTopicClick: _actions.trafficTopicClick
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Home);

exports.default = _default;